import React, { useEffect, useState, useContext } from 'react';
import Panel from '../../../components/shared/Panel/index.js';
import { Button, Grid } from 'semantic-ui-react';
import PropTypes from "prop-types";
import { MakePaymentPopup } from '../../../components/Payment/';
import { PaymentDialog } from '../../../components/Payment/paymentDialog';
import SavedCardsList from '../../../components/Payment/savedCardsList';
import _ from 'lodash';
import Currency from '../Constants/Currency';
import CreditCardActionType from '../Constants/CreditCardActionType'
import { GroupReservationContext } from '../context';
import { EntityType } from '../../../components/shared/constants.js';
import { onWarning } from '../../../components/shared/messages.js';
import { useTextResources } from '../../../language';
import { defaultAllowedPaymentProviderIDs } from '../../../components/Payment/paymentCommon';


const MethodOfPayment = ({ reservation }) => {
    const text = useTextResources();

    const { state } = useContext(GroupReservationContext);
    const [RefreshGrid, setRefreshGrid] = useState({});
    const [OpenCreditCradPopup, setOpenCreditCradPopup] = useState(false);
    const [cardSpecification, setCardSpecification] = useState({});
    const [newToken, setNewToken] = useState(undefined);

    const reservationGroup = state.ReservationGroup;
    const total = () => {
        return _.sumBy(reservationGroup.ReservationGroupReservations, r => r.Reservation.Id !== 0 ? parseFloat(r.Reservation.TotalAmountProductCurrentAfterTax) : 0).toFixed(2)
    }
    const MinimalAmountForCreditCardTest = 1;

    const OnCloseCreditCardPopup = (newToken) => {
        setOpenCreditCradPopup(false);
        setRefreshGrid(_.clone(RefreshGrid));
        if (newToken) setNewToken(
            newToken.ExtEntity ?
                {
                    ...newToken,
                    EntityTypeID: newToken.ExtEntity.find(t => t.EntityTypeID != 1).EntityTypeID,
                } :
                newToken);
    }

    const openPopup = (e, data) => {
        //validate reservation is saved:
        if (!reservation.Id) {
            return onWarning(text('SaveResevationFirst'));
        }

        if (data.method) {
            let extEntity = [];
            if (data.method.EntityTypeID == EntityType.Guest) {
                extEntity = [{ EntityID: reservation.GuestId, EntityTypeID: EntityType.Guest }];
            }
            if (data.method.EntityTypeID == EntityType.AgentID) {
                extEntity = [{ EntityID: reservation.AgentID, EntityTypeID: EntityType.AGENT }];
            }
            if (data.method.EntityTypeID == EntityType.COMPANY) {
                extEntity = [{ EntityID: reservation.CompanyID, EntityTypeID: EntityType.COMPANY }];
            }
            setCardSpecification({
                token: data.method.Token,
                Cvv: data.method.Cvv,
                actionType: data.actiontype,
                extEntity: extEntity,
                amount: total ? total() : MinimalAmountForCreditCardTest,
                currency: reservation.ReservationDailyAccommodations &&
                    reservation.ReservationDailyAccommodations[0] ? reservation.ReservationDailyAccommodations[0].CurrencyId : Currency.NIS
            });
        }
        else {
            setCardSpecification({
                actionType: data.actiontype,
                extEntity: [{ EntityID: reservation.GuestId, EntityTypeID: EntityType.Guest }],
                amount: MinimalAmountForCreditCardTest,
                currency: Currency.NIS
            });
        }
    }

    useEffect(() => {
        if (!_.isEmpty(cardSpecification)) {
            setOpenCreditCradPopup(true);
        }
    }, [cardSpecification]);

    return (
        <React.Fragment>
            <Panel header={text('CreditCards')}>
                <MakePaymentPopup
                    startOpen={OpenCreditCradPopup}
                    reservation={reservation}
                    onClose={OnCloseCreditCardPopup}
                    availableActions={[
                        PaymentDialog.Actions.SaveCreditCard,
                        PaymentDialog.Actions.TakeAuthorization
                    ]}
                    availablePanels={[
                        PaymentDialog.Panels.AddCreditCard,
                        PaymentDialog.Panels.SavedAuthorizations,
                        PaymentDialog.Panels.SavedCards,
                    ]}
                />

                <Grid divided='vertically'>
                    <Grid.Row columns={1}>
                        <Grid.Column>
                            <Button actiontype={CreditCardActionType.RegisterAndCreateToken} onClick={openPopup} floated="left" primary>{text('AddCreditCard')}</Button>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row columns={1}>
                        <Grid.Column>
                            <SavedCardsList
                                reservation={reservation}
                                hotelid={reservation.hotelId}
                                allowedPaymentProviderIDs={defaultAllowedPaymentProviderIDs}
                                newtoken={newToken}>
                            </SavedCardsList>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Panel>
        </React.Fragment>
    )
}
MethodOfPayment.propTypes = {
    reservation: PropTypes.object,
    total: PropTypes.any
}
export default MethodOfPayment;
